export default __webpack_public_path__ + "static/media/le_touquet4.c27d4c81.jpg";